var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"connect-liveroom-button",on:{"click":_vm.handleClick}},[(_vm.showIcon)?_c(_vm.iconName,{tag:"component",staticStyle:{"margin-right":"8px","cursor":"pointer"},attrs:{"theme":_vm.theme,"size":_vm.size,"fill":_vm.fill}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }